"use strict"

import React from "react"
import { Dropdown, DropdownButton } from "react-bootstrap"

import TIME_EXTRACTORS from "../../resources/TimeExtractors"
import { isLTPM } from "../../../../components/shared_components_registration"
import { withPlotSettingsConfig } from "../../../config/PlotSettingsConfigProvider"

// Where we set distinctions for LTPM/LL versions of the component
const registration = {
  day_label: (intl, timeExtractor) =>
    isLTPM ? intl.formatMessage({ id: "graphing.timelabel.day" }) : timeExtractor.name,
  timestamp_label: (intl, timeExtractor) =>
    isLTPM ? intl.formatMessage({ id: "graphing.timelabel.timestamp" }) : timeExtractor.name,
  choose_scale_label: (intl) =>
    isLTPM
      ? intl.formatMessage({ id: "general.choose", description: "Choose X-Axis Timescale Label" })
      : "Choose",
}

export const localizeTimeExtractor = (intl, timeExtractor, icons_only = false) => {
  if (timeExtractor.name === "Day") {
    return icons_only ? (
      <i className={"fa fa-list-ol"} />
    ) : (
      <span>
        <i className={"fa fa-list-ol"} />
        &nbsp;{registration.day_label(intl, timeExtractor)}
      </span>
    )
  } else {
    return icons_only ? (
      <i className={"fa fa-calendar"} />
    ) : (
      <span>
        <i className={"fa fa-calendar"} />
        &nbsp;{registration.timestamp_label(intl, timeExtractor)}
      </span>
    )
  }
}

const ToggleTimeExtractor = ({
  intl,
  timeExtractor, // From PlotSettingsProvider
  updateSettings, // From PlotSettingsProvider
  toggleAlignment,
  showLabel,
  dropToggleClass = "",
}) => {
  return (
    <>
      {showLabel && <label className={"text-center"}>{registration.choose_scale_label(intl)}:</label>}
      <DropdownButton
        id={"timeaxis"}
        variant={"outline-primary"}
        title={localizeTimeExtractor(intl, timeExtractor, true)}
        className={dropToggleClass}
      >
        {TIME_EXTRACTORS.map((te, i) => (
          <Dropdown.Item
            key={i}
            eventKey={te}
            onClick={() => {
              if (te !== timeExtractor) {
                if (toggleAlignment) {
                  updateSettings({
                    timeExtractor: te,
                    alignment: te,
                  })
                } else {
                  updateSettings({
                    timeExtractor: te,
                  })
                }
              }
            }}
            style={te === timeExtractor ? { backgroundColor: "var(--lanzalake-grey)" } : {}}
          >
            {localizeTimeExtractor(intl, te, false)}
          </Dropdown.Item>
        ))}
      </DropdownButton>
    </>
  )
}

export default withPlotSettingsConfig(ToggleTimeExtractor)
